<template lang="pug">
  v-container
    h1.black--text.text-center Create Reservation
    v-row
      v-col(cols=12 lg=3)
        v-select(:items="['Westside Middle School']" v-model='location' solo)
        v-select(:items="['Court A', 'Court B']" v-model='sub' solo)
        v-calendar.d-none
      v-col(cols=12 lg=9)
        v-card
          v-card-title.d-none
            span July 19-25
          v-calendar(:events="events" :event-color="getEventColor" type="week" interval-count=12 first-interval=8 @click:event="showEvent")
    v-dialog(v-model="dialog" max-width=800 persistent)
      v-card.pa-4
        v-card-text
          text-field(label="Location" label-width=110 disabled v-model="location")
          text-field(label="Sub-location" label-width=110 disabled v-model="sub")
          text-field(label="Time" label-width=110 disabled :value="event ? `${event.start} - ${event.end}` : ''")
          text-field(label="Team" label-width=110 value='')
          text-field(label="Purpose" label-width=110 value='')
        v-card-actions
          v-btn(color="primary" @click="dialog=false") Create Reservation
          v-btn(@click="dialog=false") Cancel
</template>

<script>
import TextField from "@/components/TextField"

export default {
  components: {
    TextField
  },
  data: () => ({
    dialog: false,
    location: 'Westside Middle School',
    sub: 'Court A',
    event: null,
    availability: {
      "Westside Middle School": {
        "Court A": [
          {
            startDtm: '2020-07-20T15:00:00',
            endDtm: '2020-07-20T19:00:00',
            available: false
          },
          {
            startDtm: '2020-07-21T15:00:00',
            endDtm: '2020-07-21T19:00:00',
            available: false
          },
          {
            startDtm: '2020-07-22T15:00:00',
            endDtm: '2020-07-22T19:00:00',
            available: false
          },
          {
            startDtm: '2020-07-23T15:00:00',
            endDtm: '2020-07-23T16:00:00',
            available: true
          },
          {
            startDtm: '2020-07-23T16:00:00',
            endDtm: '2020-07-23T17:00:00',
            available: false
          },
          {
            startDtm: '2020-07-23T17:00:00',
            endDtm: '2020-07-23T18:00:00',
            available: true
          },
          {
            startDtm: '2020-07-23T18:00:00',
            endDtm: '2020-07-23T19:00:00',
            available: true
          },
          {
            startDtm: '2020-07-24T15:00:00',
            endDtm: '2020-07-24T18:00:00',
            available: false
          },
          {
            startDtm: '2020-07-24T18:00:00',
            endDtm: '2020-07-24T19:00:00',
            available: true
          },
          {
            startDtm: '2020-07-25T11:00:00',
            endDtm: '2020-07-25T12:00:00',
            available: false
          },
          {
            startDtm: '2020-07-25T14:00:00',
            endDtm: '2020-07-25T15:00:00',
            available: true
          },
          {
            startDtm: '2020-07-25T15:00:00',
            endDtm: '2020-07-25T17:00:00',
            available: false
          }
        ],
        "Court B": [
          {
            startDtm: '2020-07-20T15:00:00',
            endDtm: '2020-07-20T19:00:00',
            available: false
          },
          {
            startDtm: '2020-07-21T15:00:00',
            endDtm: '2020-07-21T19:00:00',
            available: false
          },
          {
            startDtm: '2020-07-22T15:00:00',
            endDtm: '2020-07-22T19:00:00',
            available: false
          },
          {
            startDtm: '2020-07-23T15:00:00',
            endDtm: '2020-07-23T19:00:00',
            available: false
          },
          {
            startDtm: '2020-07-24T15:00:00',
            endDtm: '2020-07-24T19:00:00',
            available: false
          },
          {
            startDtm: '2020-07-25T11:00:00',
            endDtm: '2020-07-25T12:00:00',
            available: false
          },
          {
            startDtm: '2020-07-25T14:00:00',
            endDtm: '2020-07-25T17:00:00',
            available: false
          },
        ]
      }
    }
  }),
  computed: {
    events () {
      return this.availability[this.location][this.sub].map(item => {
        return {
          name: item.available ? 'Available' : 'Reserved',
          start: item.startDtm,
          end: item.endDtm,
          color: item.available ? 'blue' : 'grey',
          timed: true
        }
      })
    }
  },
  methods: {
    getEventColor (event) {
      return event.color
    },
    showEvent ({ event }) {
      this.event = event
      if(event.name == "Available")
        this.dialog = true
    }
  }
}
</script>